export const toDate = (value) => {
  if (value == null || value === "") return null;
  const date = typeof value.toDate === "function"
    ? value.toDate()
    : new Date(typeof value.seconds === "number" ? value.seconds * 1000 : value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const money = (value) => new Intl.NumberFormat("en-IN", {
  style: "currency", currency: "INR", maximumFractionDigits: 2,
}).format(value);

export const normalizeOrderStatus = (status) =>
  String(status || "").trim().toLowerCase();

export const orderHasStatus = (order, statuses = []) => {
  const currentStatus = normalizeOrderStatus(order?.status);
  return statuses.some(
    (status) => currentStatus === normalizeOrderStatus(status)
  );
};

export const isValidBuyerOrder = (order) => {
  if (!order) return false;
  if (typeof order === "string") return true;
  const status = (order.status || "").toLowerCase().trim();
  if (status === "created") return false;
  if (status.includes("cancel")) return false;
  return true;
};

export const summarizeDashboard = (orders, products, users, now = new Date()) => {
  const count = (statuses) =>
    orders.filter((order) => orderHasStatus(order, statuses)).length;
  const amount = (order) => Number.isFinite(Number(order.amount)) ? Number(order.amount) : 0;
  const total = orders
    .filter(isValidBuyerOrder)
    .reduce((sum, order) => sum + amount(order), 0);
  const refunded = orders.filter((order) => orderHasStatus(order, ["Refunded"]))
    .reduce((sum, order) => sum + amount(order), 0);
  const settled = orders.filter((order) => {
    const date = toDate(order.deliveredAt);
    return orderHasStatus(order, ["Delivered"]) && date && now - date > 6 * 86400000;
  }).reduce((sum, order) => sum + amount(order), 0);
  const active = users.filter((user) => {
    const date = toDate(user.loginAt);
    return date && now - date >= 0 && now - date < 5 * 86400000;
  }).length;
  const buyerUserIds = new Set();
  const buyerEmails = new Set();
  orders.forEach((o) => {
    if (!isValidBuyerOrder(o)) return;
    if (o.user?.id) buyerUserIds.add(String(o.user.id));
    if (o.userId) buyerUserIds.add(String(o.userId));
    if (o.user?.email) buyerEmails.add(String(o.user.email).toLowerCase());
    if (o.customerEmail) buyerEmails.add(String(o.customerEmail).toLowerCase());
    if (o.email) buyerEmails.add(String(o.email).toLowerCase());
  });
  const isBuyer = (user) => {
    if (Array.isArray(user.orders) && user.orders.some(isValidBuyerOrder)) return true;
    if (user.id && buyerUserIds.has(String(user.id))) return true;
    if (user.email && buyerEmails.has(String(user.email).toLowerCase())) return true;
    return false;
  };
  const actualBuyers = users.filter(isBuyer).length;
  return {
    placed: count(["Placed"]), shipped: count(["Shipped", "Out for delivery"]),
    delivered: count(["Delivered"]), cancelled: count(["Cancelled by buyer", "Cancelled by seller"]),
    refundedOrders: count(["Refunded"]), total, settled, refunded,
    unsettled: total - settled - refunded,
    hidden: products.filter((product) => product.visible === false).length,
    outOfStock: products.filter((product) => product.unitsInStock != null && Number(product.unitsInStock) === 0).length,
    lowStock: products.filter((product) => Number(product.unitsInStock) > 0 && Number(product.unitsInStock) < 5).length,
    customers: actualBuyers,
    actualBuyers,
    active, inactive: users.length - active,
  };
};
